import React, { useEffect, useLayoutEffect } from 'react';
import './productPage.css';
import saas7 from '../Images/sass7.png';
import saas8 from '../Images/sass8.png';
import saas9 from '../Images/sass9.png';
import Banner from '../Marque/Scroller';
import Footer from '../Footer/Footer';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';


function ProductPage() {
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    const animation = useAnimation();
    const [featuredRef, inView] = useInView({
        triggerOnce: true,
        rootMargin: '-100px'
    });
    useEffect(() => {
        if(inView) {
            animation.start("visible")
        }
    }, [animation, inView])
    const animation2 = useAnimation();
    const [featuredRef2, inView2] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView2) {
            animation2.start("visible")
        }
    }, [animation2, inView2])

    const animation3 = useAnimation();
    const [featuredRef3, inView3] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView3) {
            animation3.start("visible")
        }
    }, [animation3, inView3])
    const animation4 = useAnimation();
    const [featuredRef4, inView4] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView4) {
            animation4.start("visible")
        }
    }, [animation4, inView4])
    const animation5 = useAnimation();
    const [featuredRef5, inView5] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView5) {
            animation5.start("visible")
        }
    }, [animation5, inView5])
    const animation6 = useAnimation();
    const [featuredRef6, inView6] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView6) {
            animation6.start("visible")
        }
    }, [animation6, inView6])
    const transition = {duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96]};
    return (
        <>
        <div className="productPage">
            <div className="productpage__div1">
                <div className="productpage__div4">
                <div className="productpage__div2">
                    <h2 className="about1">2020</h2>
                </div>
                <div className="productpage__div3">
                    <h1 className="productPage__line1">Sass <span className="productPgae__span">Web</span></h1>
                </div>
                </div>
                <div className="productpage__div5">
                    <div className="just"></div>
                    <img src={saas7} className="productPage__img1"  />
                </div>
            </div>
            <div className="productPage__div9">
                <div className="productPage__div10">
                    <h3 className="about1">Concept</h3>
                </div>
                <div className="productPage__div11">
                    <motion.div ref={featuredRef} animate={animation} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0}}, hidden: {y: 70, opacity: 0}}} className="productPage__div12">
                        <h1 className="productPage__line">SASS CAFE is an institution</h1>
                    </motion.div>
                    <motion.div ref={featuredRef2} animate={animation2} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.2}}, hidden: {y: 70, opacity: 0}}}  className="productPage__div13">
                        <h1 className="productPage__line"> where different generations</h1>
                    </motion.div>
                    <motion.div ref={featuredRef3} animate={animation3} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.3}}, hidden: {y: 70, opacity: 0}}}  className="productPage__div14">
                        <h1 className="productPage__line">from all over the world meet</h1>
                    </motion.div>
                    <motion.div ref={featuredRef4} animate={animation4} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.4}}, hidden: {y: 70, opacity: 0}}}  className="productPage__div15">
                        <h1 className="productPage__line">This prestigious establish</h1>
                    </motion.div>
                    <motion.div ref={featuredRef5} animate={animation5} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.6}}, hidden: {y: 60, opacity: 0}}}  className="productPage__div16">
                        <h1 className="productPage__line">-ment has become a big</h1>
                    </motion.div>
                    <motion.div ref={featuredRef6} animate={animation6} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.8}}, hidden: {y: 30, opacity: 0}}}  className='productPage__div17'>
                        <h1 className="productPage__line">family from over the years.</h1>
                    </motion.div>
                </div>
            </div>
            <div className="productpage__div18">
                <div className="productPgae__div19">
                    <motion.img whileHover={{scale: 1.2}} transition={transition} src={saas8} className="productPage__img2" />
                </div>
            </div>
            <div className="productPage__div20">
                <div className="produvctPage__div21">
                    <motion.img src={saas9} whileHover={{scale: 1.2}} transition={transition} className="productPage__img3" />
                </div>
            </div>
        </div>
        <div className="about__div24"><h3>Love it!! Take a Experience</h3></div>
        <Banner />
        <Footer />
        </>
    )
}

export default ProductPage;
